var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
var __rest = (this && this.__rest) || function (s, e) {
    var t = {};
    for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0)
        t[p] = s[p];
    if (s != null && typeof Object.getOwnPropertySymbols === "function")
        for (var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++) {
            if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i]))
                t[p[i]] = s[p[i]];
        }
    return t;
};
import React, { useContext } from 'react';
import { Context } from '../context';
function IconWarningComponent(props, ref) {
    var prefixFromContext = useContext(Context).prefix;
    var _a = props.className, className = _a === void 0 ? '' : _a, prefixFromProps = props.prefix, _b = props.width, width = _b === void 0 ? '1em' : _b, _c = props.height, height = _c === void 0 ? '1em' : _c, _d = props.useCurrentColor, useCurrentColor = _d === void 0 ? false : _d, spin = props.spin, rest = __rest(props, ["className", "prefix", "width", "height", "useCurrentColor", "spin"]);
    var prefix = prefixFromProps || prefixFromContext || 'arco';
    var loadingKls = spin ? " ".concat(prefix, "-icon-loading") : '';
    return React.createElement("svg", __assign({ className: "".concat(prefix, "-icon ").concat(prefix, "-icon-warning").concat(loadingKls, " ").concat(className), width: width, height: height, viewBox: "0 0 16 16", fill: "none", xmlns: "http://www.w3.org/2000/svg" }, rest, { ref: ref }),
        React.createElement("path", { d: "M0.427387 14.2531L7.56586 1.75888C7.7578 1.42293 8.2422 1.42293 8.43414 1.75888L15.5726 14.2531C15.7631 14.5864 15.5224 15.0011 15.1385 15.0011H0.861525C0.477629 15.0011 0.236943 14.5864 0.427387 14.2531Z", fill: useCurrentColor ? 'currentColor' : '#E19F0B' }),
        React.createElement("path", { fillRule: "evenodd", clipRule: "evenodd", d: "M8.74672 6.69572C8.75406 6.50853 8.6043 6.35278 8.41698 6.35278H7.58045C7.39423 6.35278 7.24489 6.50677 7.2506 6.6929L7.353 10.0329C7.35847 10.2111 7.50453 10.3528 7.68285 10.3528H8.28597C8.46319 10.3528 8.60877 10.2128 8.61572 10.0357L8.74672 6.69572ZM8.00016 13.0006C8.46758 13.0006 8.8465 12.6217 8.8465 12.1543C8.8465 11.6869 8.46758 11.3079 8.00016 11.3079C7.53273 11.3079 7.15381 11.6869 7.15381 12.1543C7.15381 12.6217 7.53273 13.0006 8.00016 13.0006Z", fill: useCurrentColor ? 'currentColor' : '#fff' }));
}
var IconWarning = React.forwardRef(IconWarningComponent);
export default IconWarning;
